import React, { ReactNode } from 'react';
import './section.scss';

interface sectionProps {
  children?: ReactNode;
}
export const Section = (props: sectionProps) => {
  return <div className="section">{props.children}</div>;
};
